import { FeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { useGetCoInvestGpPermissions } from "@vega-api/generated/coinvest-gp-permissions/coinvest-gp-permissions";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { useBoolean } from "@vega-core/hooks/useBoolean";
import { m } from "@vega-core/paraglide/messages";
import { isGPCoInvestPortal } from "@vega-core/utils/global";
import { useFeatureFlagGuard } from "@vega-modules/hooks/useFeatureFlagGuard";
import { CommonPaths } from "@vega-modules/paths";

import { CoInvestmentPageHeader } from "../components/CoInvestmentPageHeader/CoInvestmentPageHeader";
import { CoInvestmentsList } from "../components/CoInvestmentsList/CoInvestmentsList";
import { CreateCoInvestmentModal } from "../components/CreateCoInvestmentModal/CreateCoInvestmentModal";

export const CoInvestmentsPage = () => {
  useFeatureFlagGuard(
    FeatureFlag.GP_CO_INVESTMENT,
    // Only redirect to home when not in GP co-invest portal
    isGPCoInvestPortal ? undefined : CommonPaths.Home,
  );
  const {
    isOpen: isCreateModalOpen,
    setIsOpen: setIsCreateModalOpen,
    setTrue: openCreateModal,
  } = useBoolean(false);

  const { data: canCreateDeal } = useGetCoInvestGpPermissions(undefined, {
    query: {
      select: (response) => response.data?.canCreateDeal,
    },
  });

  return (
    <>
      <div className="mt-4 mb-12">
        <CoInvestmentPageHeader
          action={
            canCreateDeal ? (
              <ThemedButton
                dataTestId="create-co-investment-button"
                onClick={openCreateModal}
                variant="primary"
              >
                {m.coInvestments_list_gp_createNew()}
              </ThemedButton>
            ) : undefined
          }
          capitalize={false}
          showDrawer={false}
          title={m.navTitles_coInvestments()}
        />
        <div className="mt-4">
          <CoInvestmentsList
            canCreateDeal={canCreateDeal}
            onCreateClick={openCreateModal}
          />
        </div>
      </div>

      <CreateCoInvestmentModal
        open={isCreateModalOpen}
        setOpen={setIsCreateModalOpen}
      />
    </>
  );
};
